import React from 'react'
import Page from '../../layouts/Page'
import Container from './Container'
import { FormattedMessage } from 'react-intl'

const AiSuggestions = () => {

  return (
    <Page
      title={<FormattedMessage id="ai_recommendations" defaultMessage={"AI Recommendations"} />}
      breadcrumbs={[
        {
          title: <FormattedMessage id="influencee" defaultMessage={"influencee"} />,
          link: "/"
        },
        {
          title: <FormattedMessage id="suggestions" defaultMessage={"Suggestions"} />,
          link: "/recommendations"
        },
        
      ]}
    >
      <Container />
    </Page>
  )
}

export default AiSuggestions